<div class="top">
    <div class="header">
        <h1 align="center">Blog</h1>
    </div>
    <div class="vc_empty_space" style="height: 30px;"><span class="vc_empty_space_inner"></span>
    </div>
    <div class="header1">
        <article id="post-6527"
            class="post-6527 post type-post status-publish format-standard hentry category-shop-ship-from-india">
            <div class="qodef-post-content">
                <div class="qodef-post-text">
                    <div class="qodef-post-text-inner clearfix">
                        <div class="qodef-post-link-holder">
                            <div class="qodef-post-link-holder-inner">
                                <h2 style="margin-bottom: 10px;">
                                    Onam Shopping from India
                                </h2>
                            </div>
                        </div>

                        <div class="qodef-post-single-content">

                            <figure class="wp-block-image"><img alt=""></figure>

                            <p></p>
                            <h4 class="has-text-align-center">Shop anything from anywhere in India. Below is just a
                                guide. Looking for more options or Indian store recommendations, Tailoring or Package
                                Pick-up services? Or Need something else from India?</h4>



                            <h5 align="center">Reach us now via WhatsApp, Facebook or Signup!</h5>



                            <div class="wp-block-columns">
                                <div class="wp-block-column">
                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07FFT3FD2/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07FFT3FD2&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=c940fe8873c554f9d4f53dfa141f92f4"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07FFT3FD2&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07FFT3FD2"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07PM7NP3L/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07PM7NP3L&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=f03299ccb450873887f39a41c23d0fc6"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07PM7NP3L&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07PM7NP3L"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B082XR3NFH/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B082XR3NFH&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=cd75e16f629d6c2a57812478c9b5a7ef"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B082XR3NFH&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B082XR3NFH"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07G45YST2/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07G45YST2&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=ce60e8d5a64f96239e4f12c98927828c"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07G45YST2&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07G45YST2"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07Y567XPG/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07Y567XPG&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=0fed886626e9b31faf5259ed700fc673"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07Y567XPG&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07Y567XPG"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">
                                </div>



                                <div class="wp-block-column">
                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B01AEOAKQK/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B01AEOAKQK&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=27428d7d52a0ba0d77975c4d36292eb6"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B01AEOAKQK&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B01AEOAKQK"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07CS2RMFX/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07CS2RMFX&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=f2a9c4c88faf72f75ae3c5dfb3abd159"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07CS2RMFX&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07CS2RMFX"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07FL6BZBX/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07FL6BZBX&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=1ebd15b64643be6ac39f9eee583f9e58"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07FL6BZBX&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07FL6BZBX"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07WT5VSFG/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07WT5VSFG&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=2996d83773550e9ddb94df5a318781aa"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07WT5VSFG&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07WT5VSFG"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B06XZCRYKH/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B06XZCRYKH&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=2da05c9872746eb598f5291bc8c6838f"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B06XZCRYKH&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B06XZCRYKH"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">
                                </div>



                                <div class="wp-block-column">
                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B08BK7RJNG/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B08BK7RJNG&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=7510471af336176d3cadd49775971161"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B08BK7RJNG&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B08BK7RJNG"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07F3DBXWV/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07F3DBXWV&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=130101cc61d4373c272b0fb526235827"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07F3DBXWV&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07F3DBXWV"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B07HRH6SQP/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B07HRH6SQP&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=aacc17f747883192bdd2a096baeb8d7e"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B07HRH6SQP&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B07HRH6SQP"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">



                                    <a target="_blank"
                                        href="https://www.amazon.in/gp/product/B015SUGHA8/ref=as_li_tl?ie=UTF8&amp;camp=3638&amp;creative=24630&amp;creativeASIN=B015SUGHA8&amp;linkCode=as2&amp;tag=yourdesicart-21&amp;linkId=0bb22634c45051dda4f2dbd957938c5d"
                                        rel="noopener noreferrer"><img border="0"
                                            src="//ws-in.amazon-adsystem.com/widgets/q?_encoding=UTF8&amp;MarketPlace=IN&amp;ASIN=B015SUGHA8&amp;ServiceVersion=20070822&amp;ID=AsinImage&amp;WS=1&amp;Format=_SL250_&amp;tag=yourdesicart-21"></a><img
                                        src="//ir-in.amazon-adsystem.com/e/ir?t=yourdesicart-21&amp;l=am2&amp;o=31&amp;a=B015SUGHA8"
                                        width="1" height="1" border="0" alt=""
                                        style="border:none !important; margin:0px !important;">
                                    <p></p>
                                </div>
                            </div>
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="qodef-post-info-below clearfix">
            </div>
        </article>
    </div>

    <footer>
        <div class="row col-xs-12 col-sm-12 col-md-12" id="footer">
            <div class="col-xs-12 col-sm-4">
                <div id="cvvv">
                    <h4 class="title">yourDesiCart</h4>
                    <div class="textwidget">
                        <div class="vc_empty_space" style="height: 12px"><span class="vc_empty_space_inner"></span>
                        </div>


                        <p>84 High street, Kondapur Hyderabad 500084</p>
                        <p>Email: yourDesiCart@gmail.com</p>
                        <p>Phone: +91 8328579397</p>
                        <div class="vc_empty_space" style="height: 32px"><span class="vc_empty_space_inner"></span>
                        </div>
                        <span style="margin: 0px 5px 0px 0px">
                            <a itemprop="url" class="" href="https://www.facebook.com/yourDesiCart" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-facebook qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://twitter.com/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-twitter qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.linkedin.com/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-linkedin qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.instagram.com/yourDesiCart" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-instagram qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://in.pinterest.com/yourDesiCart/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-pinterest qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.youtube.com" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-youtube-play qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <!-- <div class="vertical-line" style="height: 200px;width:0.1px; color: silver"></div>
                        <div class="col-xs-12 col-sm-3">
                            <div class="qodef-column" style="margin-top: 40px;margin-left: 15px;">
            
                                <div class="textwidget custom-html-widget"><a href="terms-of-use">Terms of
                                        Use</a></div>
            
                                <div id="custom_html-3" class="widget_text widget qodef-footer-column-2 widget_custom_html">
                                    <div class="textwidget custom-html-widget"><a href="prohibited-items">Prohibited
                                            Items</a></div>
                                </div>
                            </div>
                        </div> -->
            <div class="vertical-line" style="height: 200px;"></div>
            <div class="col-xs-12 col-sm-4">

                <div id="cvvv">
                    <h4 class="title" style="margin-left: 15px;">Quick Links</h4>
                    <ul>
                        <li>
                            <a [routerLink]="[]" (click)="personal()">Personal
                                Shopper from India</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="onamshopping()">Onam
                                Shopping from India</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="tosis()">To Sis, With
                                Love</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="provibited()">Prohibited
                                Items</a>
                        </li>


                        <li>
                            <a [routerLink]="[]" (click)="terms()">Terms of
                                Use</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="vertical-line" style="height: 200px;"></div>
            <div class="col-xs-12 col-sm-3">
                <div id="cvvv">
                    <h4 class="title" style="margin-left: 15px;">ContactUs</h4>
                    <ul>
                        <li>
                            <a [routerLink]="[]" (click)="contactUs()">ContactUs</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</div>